import axios from 'axios';
import tokenRefreshHandler from './TokenRefreshHandler';

// 1. NON impostare il baseURL qui. Lo faremo dinamicamente nell'intercettore.
const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
    }
});

// 2. L'intercettore di richiesta ora ha un doppio ruolo:
//    - Impostare il baseURL corretto per OGNI richiesta
//    - Aggiungere il token/chiave di autenticazione
api.interceptors.request.use(
    (config) => {
        const API_URL = (window._env_?.REACT_APP_API_URL || '/api').replace(/\/$/, '');

        // Imposta il baseURL sulla configurazione della singola richiesta.
        config.baseURL = API_URL;

        // Aggiorna l'URL di base anche nel token refresh handler ad ogni richiesta, per sicurezza.
        tokenRefreshHandler.apiUrl = API_URL;

        const token = localStorage.getItem('token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else if (window.location.pathname.startsWith('/warehouse-dashboard')) {
            const apiKey = window._env_?.REACT_APP_BOT_API_SECRET_KEY;
            if (apiKey) {
                config.headers['x-api-key'] = apiKey;
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// ✅ CORREZIONE: Lista delle rotte pubbliche che NON devono reindirizzare al login
const PUBLIC_ROUTES = [
    '/login',
    '/reset-password',
    '/fill-schedule',
    '/warehouse-dashboard',
    '/acknowledge'
];

// Helper per verificare se siamo su una rotta pubblica
const isPublicRoute = () => {
    return PUBLIC_ROUTES.some(route => window.location.pathname.startsWith(route));
};

// L'interceptor per le risposte con gestione delle rotte pubbliche
api.interceptors.response.use(
    (response) => {
        const newToken = response.headers['new-token'];
        if (newToken) {
            localStorage.setItem('token', newToken);
            localStorage.setItem('tokenTimestamp', Date.now().toString());
            api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            console.log('Token aggiornato passivamente dall\'header new-token.');
        }

        // Se la richiesta richiede la response completa (es. per leggere gli headers), restituisci 'response'.
        if (response.config && response.config.returnFullResponse) {
            return response;
        }

        return response.data;
    },
    async (error) => {
        const originalRequest = error.config;

        // ✅ NUOVA LOGICA: Se siamo su una rotta pubblica, NON gestiamo il 401 come logout
        if (isPublicRoute()) {
            const message = error.response?.data?.message || error.response?.data?.error || error.message;
            return Promise.reject(new Error(message || 'Errore API'));
        }

        // ✅ Gestione normale del 401 solo per rotte protette
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const tokenExists = !!localStorage.getItem('token');
            if (!tokenExists) {
                if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/warehouse-dashboard')) {
                    window.location.href = '/login';
                }
                return Promise.reject(error);
            }

            const refreshSuccess = await tokenRefreshHandler.refreshToken();

            if (refreshSuccess) {
                return api(originalRequest);
            } else {
                if (!window.__alreadyRedirectedToLogin) {
                    window.__alreadyRedirectedToLogin = true;
                    localStorage.clear();
                    if (window.location.pathname !== '/login') {
                        window.location.href = '/login';
                    }
                }
            }
        }

        const message = error.response?.data?.message || error.response?.data?.error || error.message;
        return Promise.reject(new Error(message || 'Errore API sconosciuto'));
    }
);

export default api;